import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import ToastrService from '@/shared/services/ToastrService';
import handleHttpError from '@/shared/services/HandleHttpError';
import SharepointModal from '@/modules/documents/modals/SharepointModal';

const RelationSharepointLinkModal = ({ show, intl, relationId, onClose }) => {
  const handleLinkConfirmed = linkData =>
    api.base
      .post(`${config.appUrls.api}/api/relation/${relationId}/sharepoint-link`, linkData)
      .then(
        () => {
          ToastrService.success();
          onClose();
        },
        error => {
          handleHttpError(intl)(error);
        },
      );

  return (
    <SharepointModal
      show={show}
      intl={intl}
      mode="link"
      onLinkConfirmed={handleLinkConfirmed}
      onClose={onClose}
    />
  );
};

RelationSharepointLinkModal.propTypes = {
  show: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  relationId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default injectIntl(RelationSharepointLinkModal);
